// Farbe und Symbol je Status-Stufe. Tickets haben kein eigenes Symbol-Feld – statt
// eines geratenen Gewerks (Prototyp: Thermometer, Glühbirne …) zeigt die App die Stufe.
import { CheckCircle, CircleDashed, Hammer, Key, SignIn, SignOut, type Icon } from '@phosphor-icons/react';
import type { PortalFarbe, StatusTon } from '../../components/portal/bausteine';
import type { StatusStufe } from '../../lib/hausmeister/darstellung';
import type { Art } from '../../lib/uebergabe/typen';

export const STUFE_STIL: Record<StatusStufe, { farbe: PortalFarbe; icon: Icon; ton: StatusTon }> = {
  offen: { farbe: 'grau', icon: CircleDashed, ton: 'neutral' },
  in_bearbeitung: { farbe: 'orange', icon: Hammer, ton: 'warn' },
  erledigt: { farbe: 'gruen', icon: CheckCircle, ton: 'ok' },
};

export const ART_STIL: Record<Art, { farbe: PortalFarbe; icon: Icon }> = {
  einzug: { farbe: 'gruen', icon: SignIn },
  auszug: { farbe: 'orange', icon: SignOut },
  kauf: { farbe: 'schluessel', icon: Key },
};
